import React from "react";
import { Link, useLocation } from "react-router-dom";

const BreadCrumb = () => {
  const location = useLocation();
  const path = location.pathname.split("/").filter(Boolean); // Split the path into segments
  const categoryName = localStorage.getItem('categoryName') || 'Home';

  return (
    <section className="inner-header">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
          
          </div>
        </div>
      </div>
    </section>
  );
};

export default BreadCrumb;
